import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../Contexts/LanguageContext';
import styles from './LanguageSelector.module.css';

const LanguageSelector = () => {
  const { currentLanguage, changeLanguage, languages } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLang = languages.find(lang => lang.code === currentLanguage) || languages[0];

  // Map language codes to country codes for flags
  const flagMap = {
    'pt': 'pt',
    'es': 'es',
    'fr': 'fr',
    'en': 'gb',
    'it': 'it',
    'de': 'de'
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLanguageChange = (langCode) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className={styles.languageSelector} ref={dropdownRef}>
      <button
        className={styles.languageButton}
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Select Language"
      >
        <img
          src={`https://flagcdn.com/24x18/${flagMap[currentLang.code]}.png`}
          srcSet={`https://flagcdn.com/48x36/${flagMap[currentLang.code]}.png 2x`}
          alt={currentLang.name}
          className={styles.flagImage}
        />
        <i className={`fas fa-chevron-down ${styles.chevron} ${isOpen ? styles.open : ''}`}></i>
      </button>

      {isOpen && (
        <div className={styles.dropdown}>
          {languages.map((lang) => (
            <button
              key={lang.code}
              className={`${styles.languageOption} ${lang.code === currentLanguage ? styles.active : ''}`}
              onClick={() => handleLanguageChange(lang.code)}
            >
              <img
                src={`https://flagcdn.com/24x18/${flagMap[lang.code]}.png`}
                srcSet={`https://flagcdn.com/48x36/${flagMap[lang.code]}.png 2x`}
                alt={lang.name}
                className={styles.optionFlagImage}
              />
              <span className={styles.optionName}>{lang.name}</span>
              {lang.code === currentLanguage && (
                <i className="fas fa-check" style={{ marginLeft: 'auto', color: '#10b981' }}></i>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
